import { render } from "./image_multi.vue?vue&type=template&id=6ce17d55"
import script from "./image_multi.vue?vue&type=script&lang=js"
export * from "./image_multi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__